<template>
    <div class="fixed backdrop-blur-2xl bg-white bg-opacity-35 bottom-6 right-6 flex items-center shadow-neon p-3 rounded-full cursor-pointer">
      <a href="https://wa.me/message/Q4ZX3LQ33G5WN1" target="_blank" class="flex items-center">
        <img src="../assets/imagenes/whatsapp.png" alt="WhatsApp" class="w-10 h-10 mr-2">
        <div class="hidden md:block">
          <p class="font-semibold">Call Center</p>
          <!-- <p class="text-sm font-medium">Chatea con nosotros</p> -->
        </div>
      </a>
    </div>
  </template>
  
  <script>
  export default {
    name: 'FloatingChatButton',
  };
  </script> 